'use strict';

var packs = function () {

    var _getPacks = function _getPacks(packsArray) {
        var $packsContainer = $('.js-packs-container'),
            $tabBlock = $('.js-pack-card'),
            $newTabBlock = $tabBlock.remove().clone();

        if (packsArray != null) {
            packsArray.map(function (pack) {
                var $targetBlock = $newTabBlock.clone();
                $targetBlock.find('.js-pack-title').text(pack.vname);
                $targetBlock.find('.js-pack-image').attr({ src: pack.vimage, alt: pack.vname });
                $targetBlock.find('.js-pack-description').text(pack.vdescription);
                $packsContainer.append($targetBlock);
            });
            $('.js-packs-section').removeClass('hidden');
        }
    };

    var _expandPack = function _expandPack() {
        $('.js-expand-pack').click(function (event) {
            $(event.target).parent().hasClass('open') ? $(event.target).parent().removeClass('open') : $(event.target).parent().addClass('open');
        });
    };

    var _init = function _init(packsArray) {
        _getPacks(packsArray);
        _expandPack();
    };

    return {
        init: _init
    };
}();